module.exports = __webpack_public_path__ + "img/pc-banner.5800eb0.jpg";